import wash from "../../assets/images/icon-wash.svg";
import vacuum from "../../assets/images/icon-clean.svg";
export const aboutData = [
  {
    img: wash,
    title: "Automated Wash",
    body: "We guarantee you the best car wash experience, exceptional service",
  },
  {
    img: vacuum,
    title: "Vacuum Clean",
    body: "We guarantee you the best car wash experience, exceptional service",
  },
  {
    img: wash,
    title: "Automated Wash",
    body: "We guarantee you the best car wash experience, exceptional service",
  },
  {
    img: vacuum,
    title: "Vacuum Clean",
    body: "We guarantee you the best car wash experience, exceptional service",
  },
  {
    img: wash,
    title: "Automated Wash",
    body: "We guarantee you the best car wash experience, exceptional service",
  },
  {
    img: vacuum,
    title: "Vacuum Clean",
    body: "We guarantee you the best car wash experience, exceptional service",
  },
];
